import { EventNames } from '@farmasiet/frontendcore-reactcomponents';
import * as React from 'react';

import { getTranslation, keys } from '../../../../Resources/Translations';
import { post } from '../../../ReactComponents/API';
import { ModalText } from '../../../ReactComponents/Modal/Modal';
import { SessionNotificationModal } from '../../../ReactComponents/Modal/SessionNotificationModal';

export interface RxSessionExpiredModalProps {
    expirationDate: number | null;
    bankIdLoginUrl: string;
    acknowledgeRxsRemovedUrl: string;
    validateBeforeShowing: () => Promise<boolean>;
    requiresSecureLogin: boolean;
}

export const showRxSessionExpiredModal = () => {
    window.dispatchEvent(new CustomEvent(EventNames.RxItemsRemoved));
};

export const RxSessionExpiredModal = ({
    expirationDate,
    bankIdLoginUrl,
    acknowledgeRxsRemovedUrl,
    validateBeforeShowing,
    requiresSecureLogin
}: RxSessionExpiredModalProps) => {
    const dismissDateKeyExpired = 'RxSessionExpiredDismissDate';

    const additionalContentExpired = () => {
        return (
            <div className="RxSessionModal__ContentWrapper">
                <div className="RxSessionModal__ImageWrapper">
                    <img src="/dist/assets/images/register.svg" alt="" className="RxSessionModal__Image" aria-hidden />
                </div>
                <ModalText>{getTranslation(keys['modal.rxSession.expiredBody'])}</ModalText>
            </div>
        );
    };

    const onConfirm = () => {
        post(acknowledgeRxsRemovedUrl).finally(() => {
            if (window.dispatchEvent(new CustomEvent(EventNames.RxLoginRequest, { cancelable: true }))) {
                window.location.href = bankIdLoginUrl;
            }
        });
    };

    const onClose = () => {
        post(acknowledgeRxsRemovedUrl).finally(() => {
            if (requiresSecureLogin) window.location.href = '/';
        });
    };

    return (
        <SessionNotificationModal
            className="RxSessionModal__Expired"
            onConfirm={onConfirm}
            onClose={onClose}
            confirmButton={<div className="RxSessionModal__ExpiredConfirmButton">{getTranslation(keys['modal.rxSession.logIn'])}</div>}
            cancelLabel={getTranslation(keys['modal.rxSession.close'])}
            heading={getTranslation(keys['modal.rxSession.expiredHeading'])}
            additionalContent={additionalContentExpired()}
            expirationDate={expirationDate}
            dismissKey={dismissDateKeyExpired}
            maxNotificationThresholdMs={0}
            sessionEndedEvent={EventNames.RxItemsRemoved}
            validateBeforeShowing={validateBeforeShowing}
            showDragHandle={true}
        />
    );
};
